import { combineReducers } from 'redux'

import design from "./design";
import row from "./row";
import alert from "./alert";

export default combineReducers({
    row,
    design,
    alert
  })